/* eslint-disable camelcase */
import format from 'date-fns/format';

import { DATE_FORMAT } from '../constants';
import { Query, SearchParams } from '../types';
import convertRoomsForQuery from './convertRoomsForQuery';

type Params = Omit<SearchParams, 'maxDays'>;

const getQueryFromSearchParams = (data: Params): Query => {
  const { to, startDate, endDate, rooms = [], earlyCheckin, lateCheckout } = data;

  let additionalParams: Query = {};

  additionalParams.rooms = convertRoomsForQuery(rooms);

  if (to) {
    const { id, type, country_code, timezone_gmt, name } = to;

    additionalParams = {
      ...additionalParams,
      id,
      type,
      country_code,
      timezone_gmt,
      to: name ? encodeURIComponent(name) : undefined,
    };
  }

  if (earlyCheckin) {
    additionalParams.e_checkin = earlyCheckin;
  }

  if (lateCheckout) {
    additionalParams.l_checkout = lateCheckout;
  }

  return {
    date_start: format(startDate, DATE_FORMAT),
    date_end: format(endDate, DATE_FORMAT),
    ...additionalParams,
  };
};

export default getQueryFromSearchParams;
